import React, { useEffect, useState } from "react";
import HocPopup from "../../../../hoc/hocPopup";
import {
  Box,
  IconButton,
  Paper,
  Typography,
  Table,
  TableRow,
  TableCell,
  TableHead,
  TableBody,
  Divider,
  MenuItem,
  Menu,
  useTheme,
  Switch,
} from "@mui/material";
import { Edit, Person, Refresh } from "@mui/icons-material";
import {
  TYPE,
  capitalizeFirstLetter,
  formatMonth,
  today,
} from "../../../../utils/Utils";
import EmailOutlinedIcon from "@mui/icons-material/EmailOutlined";
import LocalPhoneOutlinedIcon from "@mui/icons-material/LocalPhoneOutlined";
import UpdateDealershipDialog from "./dialog/dialogBody/UpdateDealership.dialog";
import { useNavigate, useParams } from "react-router-dom";
import BreadcrumbsComponent from "../../../base/Breadcrumbs.component";
import AppButton from "../../../base/AppButton.component";
import DealershipStyles from "./Dealership.styles";
import { useMutation, useQuery } from "@apollo/client";
import {
  DEALERSHIP_BILLING,
  GET_DEALERSHIPS,
} from "../../../../graphql/query/query";
import { useAuth } from "../../../../context/Auth.context";
import { useLayoutEffect } from "react";
import { useAppContext } from "../../../../context/App.context";
import AddDealershipDialog from "./dialog/dialogBody/AddDealership.dialog";
import NO_IMAGE from "../../../../assets/images/no-image.jpg";
import {
  MANAGE_CRM_USERS,
  MANAGE_DEALERSHIP,
} from "../../../../graphql/mutation/mutation";
import DeactivateDialog from "./dialog/dialogBody/Deactivate.dialog";
import { getStateCode, states } from "../../../../utils/StatesList.utils";
import moment from "moment";

const getCurrentMonthPayload = (subscriptions) => {
  const currentDate = new Date();
  const currentMonthSubscriptions = subscriptions.filter((sub) => {
    const subscriptionDate = new Date(sub.date);
    return (
      subscriptionDate.getMonth() === currentDate.getMonth() &&
      subscriptionDate.getFullYear() === currentDate.getFullYear()
    );
  });
  let totalPayload = 0;
  currentMonthSubscriptions.forEach((sub) => {
    totalPayload += sub.payload;
  });
  let totalRequestCount = currentMonthSubscriptions[0]?.totalRequestCount;
  console.log("total", totalPayload);
  return { totalPayload, totalRequestCount };
};

const DealershipDetailComponent = ({ dialog }) => {
  const navigate = useNavigate();
  const theme = useTheme();
  const app = useAppContext();
  const auth = useAuth();
  const params = useParams();
  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);
  const [details, setDetails] = useState([]);
  const [dealership, setDealership] = useState();

  const breadcrumb = {
    title: dealership?.full_name || "Dealership Details",
    links: [
      { path: "/", name: "Dealership" },
      { path: null, name: dealership?.full_name || "Details" },
    ],
  };
  const {
    data: dealershipData,
    refetch: dealershipRefetch,
    loading,
  } = useQuery(GET_DEALERSHIPS, {
    variables: {
      filterInput: {
        dealership_id: parseInt(params?.dealershipId),
        city: "",
        dealership_name: "",
        email: "",
        date: today,
        rowsPerPage: app.fetchData.a_rowsPerPage,
        pageCount: app.fetchData.a_pageCount,
      },
    },
    fetchPolicy: "network-only",
    notifyOnNetworkStatusChange: true,
  });

  useEffect(() => {
    if (dealershipData?.getDealerships?.dealerships) {
      app.setDealerships({
        dealerships: dealershipData?.getDealerships?.dealerships,
      });
    }
  }, [dealershipData]);

  const [manageDealership, { loading: updateLoading, data: Dealership }] =
    useMutation(MANAGE_DEALERSHIP);
  const [checked, setChecked] = useState(false);

  useEffect(() => {
    if (dealership) {
      console.log("deallllll", dealership?.crm_user_status);
      setChecked(dealership?.crm_user_status);
    }
  }, [dealership]);

  const [manageCrmUser, { data: CrmUserOutput, loading: crmLoading }] =
    useMutation(MANAGE_CRM_USERS);

  console.log("checked", checked);
  const crmSwitchHandle = async (event) => {
    console.log("event", event.target.checked);

    // setChecked(event.target.checked);
    await manageCrmUser({
      variables: {
        crmInput: {
          dealership_id: params?.dealershipId,
          crm_user_status: event.target.checked,
        },
      },
    });

    await dealershipRefetch({
      filterInput: {
        city: "",
        dealership_name: "",
        email: "",
        date: today,
        rowsPerPage: app.fetchData.a_rowsPerPage,
        pageCount: app.fetchData.a_pageCount,
      },
    });
    setChecked(event.target.checked);
  };

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };
  const deactivateHandler = () => {
    manageDealership({
      variables: {
        dealershipInput: {
          dealership_id: params.dealershipId,
          is_active: false,
        },
      },
    });
  };

  const activateHandler = () => {
    manageDealership({
      variables: {
        dealershipInput: {
          dealership_id: params.dealershipId,
          is_active: true,
        },
      },
    });
  };

  const { data, refetch } = useQuery(DEALERSHIP_BILLING, {
    variables: {
      billingInput: {
        dealership_id: params.dealershipId,
        date: moment(new Date()).format("YYYY-MM-DD"),
      },
    },
  });

  useLayoutEffect(() => {
    if (data?.dealershipBilling?.billing) {
      setDetails([...data.dealershipBilling.billing]);
    }
  }, [data]);

  useEffect(() => {
    if (app.dealerships) {
      app?.dealerships?.dealerships?.map((dealership) => {
        if (params.dealershipId == dealership.dealership_id) {
          setDealership(dealership);
        }
      });
    }
  }, [dealershipData, app?.dealerships]);

  return (
    <>
      <BreadcrumbsComponent {...breadcrumb} />
      <Box sx={{ display: "flex", flexDirection: "row" }}>
        <Box width={"75%"} height={"100%"} padding={"12px"}>
          <Paper sx={DealershipStyles.detailPaper}>
            <Table stickyHeader>
              <TableHead>
                <TableRow>
                  <TableCell sx={DealershipStyles.tableCell}>Month</TableCell>
                  <TableCell sx={DealershipStyles.tableCell}>
                    Subscription Cost
                  </TableCell>
                  <TableCell sx={DealershipStyles.tableCell}>
                    Max pull
                  </TableCell>
                  <TableCell sx={DealershipStyles.tableCell}>
                    # of Pulls
                  </TableCell>
                  <TableCell sx={DealershipStyles.tableCell}>
                    Per Pull Overage
                  </TableCell>
                  <TableCell sx={DealershipStyles.tableCell}>
                    Total Cost
                  </TableCell>
                  <TableCell sx={DealershipStyles.tableCell}>
                    Request Quote Cost
                  </TableCell>
                  <TableCell sx={DealershipStyles.tableCell}>Payload</TableCell>

                  <TableCell sx={DealershipStyles.tableCell}>
                    <IconButton
                      onClick={() => {
                        // setDetails([]);
                        refetch();
                        dealershipRefetch();
                      }}
                      edge="start"
                    >
                      {<Refresh />}
                    </IconButton>
                  </TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {details.map((res) => {
                  return (
                    <TableRow>
                      <TableCell
                        align="center"
                        sx={DealershipStyles.detailTableCell}
                      >
                        {res.date ? <>{formatMonth(res.date)}</> : "N/A"}
                      </TableCell>
                      <TableCell
                        align="center"
                        sx={DealershipStyles.detailTableCell}
                      >
                        {"$ " + res.cost.toFixed(2) || "0"}
                      </TableCell>
                      <TableCell
                        align="center"
                        sx={DealershipStyles.detailTableCell}
                      >
                        {res.limit || "0"}
                      </TableCell>
                      <TableCell
                        align="center"
                        sx={DealershipStyles.detailTableCell}
                      >
                        {res.totalCount}
                      </TableCell>
                      <TableCell
                        align="center"
                        sx={DealershipStyles.detailTableCell}
                      >
                        {"$ " + res.overage_cost.toFixed(2) || "0"}
                      </TableCell>
                      <TableCell
                        align="center"
                        sx={DealershipStyles.detailTableCell}
                      >
                        {"$ " +
                          (res.cost +
                            (res.totalCount > res.limit
                              ? res.totalCount - res.limit
                              : 0) *
                              res.overage_cost)}
                      </TableCell>

                      <TableCell
                        align="center"
                        sx={DealershipStyles.detailTableCell}
                      >
                        {"$ " + res.quote_cost.toFixed(2) || "0"}
                      </TableCell>

                      {console.log("details", res)}

                      <TableCell
                        align="center"
                        sx={DealershipStyles.detailTableCell}
                      >
                        {res?.payload
                          ? res?.payload === 2
                            ? "Docs & Data"
                            : res.payload === 1
                            ? "Data"
                            : "N/A"
                          : "N/A"}
                      </TableCell>
                    </TableRow>
                  );
                })}
              </TableBody>
            </Table>
          </Paper>
        </Box>

        <Box width={"25%"} height={"100%"} padding={"12px"}>
          <Paper sx={DealershipStyles.rightDetailPaper}>
            <Box sx={DealershipStyles.detailBox}>
              <Box>
                <Box sx={DealershipStyles.detailFirstBox}>
                  <Box sx={DealershipStyles.detailSecondBox}>
                    <IconButton
                      color="inherit"
                      aria-label="open drawer"
                      sx={DealershipStyles.iconButton}
                      onClick={handleClick}
                    >
                      <Edit color="primary" />
                    </IconButton>
                    <Menu
                      anchorEl={anchorEl}
                      open={open}
                      onClose={handleClose}
                      MenuListProps={{
                        "aria-labelledby": "basic-button",
                      }}
                    >
                      <MenuItem
                        onClick={() => {
                          navigate(`/createDealership/${params.dealershipId}`);

                          // dialog({
                          //   open: true,
                          //   bodyType: TYPE.EDIT_DEALERSHIP,
                          //   body: (
                          //     <AddDealershipDialog
                          //       edit={true}
                          //       data={dealership}
                          //     />
                          //   ),
                          //   maxWidth: "md",
                          // });
                        }}
                      >
                        Edit Dealership
                      </MenuItem>
                      <MenuItem
                        onClick={() => {
                          dialog({
                            open: true,
                            bodyType: TYPE.UPDATE_SUBSCRIPTION,
                            body: <UpdateDealershipDialog data={details[0]} />,
                            maxWidth: "sm",
                          });
                        }}
                      >
                        Update Subscription
                      </MenuItem>
                      <MenuItem
                        onClick={() => {
                          navigate(`/dealershipUsers/${params.dealershipId}`);
                        }}
                      >
                        Manage Users
                      </MenuItem>
                    </Menu>
                  </Box>
                </Box>

                <Box sx={DealershipStyles.logoBox}>
                  <img
                    src={dealership?.logo_url || NO_IMAGE}
                    width={100}
                    alt="logo"
                  />
                  <Typography
                    variant="h6"
                    sx={{
                      margin: "20px",
                    }}
                  >
                    {capitalizeFirstLetter(dealership?.full_name)}
                  </Typography>
                </Box>

                <Box
                  sx={[
                    DealershipStyles.statusBox,
                    {
                      backgroundColor: dealership?.is_active
                        ? "#e8f4ea"
                        : "#F2E7E8",
                    },
                  ]}
                >
                  <Box
                    style={{
                      height: "10px",
                      width: "10px",
                      borderRadius: "5px",
                      justifyContent: "center",
                      backgroundColor: dealership?.is_active
                        ? "#00ab55"
                        : "#E15656",
                    }}
                  />
                  <Typography
                    variant="caption"
                    fontWeight={"bold"}
                    color={dealership?.is_active ? "primary" : "error"}
                  >
                    {dealership?.is_active ? "Active" : "Deactivated"}
                  </Typography>
                </Box>

                <Box sx={DealershipStyles.personIcon}>
                  <Person color="primary" />
                  <Typography color="primary" fontWeight={"bold"}>
                    {dealership?.main_contact?.last_name
                      ? dealership?.main_contact?.first_name +
                        " " +
                        dealership?.main_contact?.last_name
                      : "N/A"}
                  </Typography>
                </Box>

                <Typography sx={DealershipStyles.detailButton}>
                  {dealership?.city
                    ? dealership?.number +
                      " " +
                      dealership?.street +
                      " " +
                      dealership?.city +
                      " " +
                      getStateCode(dealership?.state, states) +
                      " " +
                      dealership?.zipcode
                    : "N/A"}
                </Typography>

                <Box
                  sx={{
                    backgroundColor: "#e8f4ea",
                    borderRadius: "6px",
                    marginY: "16px",
                    paddingX: "48px",
                  }}
                  padding={"16px"}
                >
                  <Box sx={DealershipStyles.emailIcon}>
                    <EmailOutlinedIcon />
                    <Typography>{dealership?.email || "N/A"}</Typography>
                  </Box>
                  <Box sx={DealershipStyles.phoneIcon}>
                    <LocalPhoneOutlinedIcon />
                    <Typography>{dealership?.phone_number || "N/A"}</Typography>
                  </Box>
                </Box>

                <Box
                  sx={{
                    display: "flex",
                    flexDirection: "row",
                    marginBottom: "10px",
                  }}
                >
                  <Switch
                    // value={checked}
                    checked={checked}
                    size="small"
                    onChange={crmSwitchHandle}
                    disabled={loading || crmLoading}
                  />

                  <Typography sx={{ marginLeft: "10px" }}>
                    Enable CRM User
                  </Typography>
                </Box>

                <Divider />
                <Box paddingY={"8px"} sx={DealershipStyles.pullCount}>
                  <Typography>Total pull count</Typography>
                  <Typography>
                    {details?.reduce(
                      (value, number) => value + number.totalCount,
                      0
                    ) || 0}
                  </Typography>
                </Box>
                <Box paddingY={"8px"} sx={DealershipStyles.pullCount}>
                  <Typography>Receive Payload</Typography>
                  <Typography>
                    {console.log("detailssss", details)}
                    {/* {details[0]?.payload == 1
                      ? "Data"
                      : details[0]?.payload == 2
                      ? "Docs & Data"
                      : "N/A"} */}
                    {getCurrentMonthPayload(details).totalPayload == 1
                      ? "Data"
                      : getCurrentMonthPayload(details).totalPayload == 2
                      ? "Docs & Data"
                      : details[0]?.payload == 1
                      ? "Data"
                      : details[0]?.payload == 2
                      ? "Docs & Data"
                      : "N/A"}
                  </Typography>
                </Box>
                <Box paddingY={"8px"} sx={DealershipStyles.pullCount}>
                  <Typography>Quotes Request Count</Typography>
                  <Typography>
                    {getCurrentMonthPayload(details).totalRequestCount}
                  </Typography>
                </Box>
                <Divider />
              </Box>

              <Box>
                <Box sx={DealershipStyles.detailButton}>
                  <AppButton
                    variant="text"
                    // buttonText="Deactivate Dealership"
                    buttonText={
                      !dealership?.is_active
                        ? "Activate Dealership"
                        : "Deactivate Dealership"
                    }
                    clickHandler={() => {
                      dialog({
                        open: true,
                        bodyType: TYPE.DEACTIVATE_DEALER,
                        maxWidth: "sm",
                        body: (
                          <DeactivateDialog
                            deactivateHandler={deactivateHandler}
                            dealership={dealership}
                            activateHandler={activateHandler}
                          />
                        ),
                      });
                    }}
                    sx={{ color: theme.palette.error.main }}
                    // disabled={!dealership?.is_active}
                  />
                </Box>
              </Box>
            </Box>
          </Paper>
        </Box>
      </Box>
    </>
  );
};

export default HocPopup(DealershipDetailComponent);
